import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { UserContext, SnackbarContext } from "../../contexts";
import { useInput } from "../../hooks";
import { FormInput, Button } from "../../components";
import API from "../../api";
import Util from "../../util";
import { useTranslation } from "react-i18next";

export const UserFindPwPage = (props) => {
  const { t } = useTranslation(); // useTranslation 훅을 사용하여 t 함수를 가져옴

  const history = useHistory();
  const { updateToken } = useContext(UserContext);
  console.log("[render - LoginPage]", history);
  const [form, onChangeForm, resetForm] = useInput({ id: "", name: "" });
  console.log("[render - form afer]", history);
  const { updateSnackbar } = useContext(SnackbarContext);

  const requestFindPw = () => {
    console.log("requestFindPw");

    if (!Util.Regexp.EMAIL.test(form.id)) {
      updateSnackbar({
        type: "error",
        open: true,
        message: t("signup.alert.no_id"),
      });
      return;
    }

    let body = {
      id: form.id,
      name: form.name,
    };
    API.Member.PutFindPassword(body).then(
      (res) => {
        console.log("res", res);
        updateSnackbar({
          type: "info",
          open: true,
          message: t("find_pw.alert.success"),
        });
        history.push("/login");
      },
      (err) => {
        updateSnackbar({
          type: "error",
          open: true,
          message: err.data.message,
        });
      }
    );
  };

  return (
    <article className="login-page">
      <section className="login__container card">
        <section className="logo__box">
          <div
            className="ico logo big"
            onClick={() => {
              history.push("/");
            }}
          ></div>
        </section>
        <section className="input__box">
          <FormInput
            label={t("form.label.id")}
            value={form.id}
            name={"id"}
            onChange={onChangeForm}
            placeholder={t("form.placeholder.id")}
          ></FormInput>
          <FormInput
            label={t("form.label.name")}
            value={form.name}
            name={"name"}
            onChange={onChangeForm}
          ></FormInput>
        </section>
        <section className="button__box">
          <Button
            label={t("find_pw.button.confirm")}
            onClick={requestFindPw}
          ></Button>
        </section>
        <section className="guide-text__box">
          <p>{t("find_pw.guide.text")}</p>
        </section>
        <section className="guide-text-notice__box">
          <p>{t("find_pw.guide.notice")}</p>
        </section>
        <section
          className="option__box"
          style={{ justifyContent: "center", marginBottom: 8 }}
        >
          <span
            style={{ marginRight: 24 }}
            onClick={() => {
              history.push("/");
            }}
          >
            {t("signup.button.home")}
          </span>
          <span
            onClick={() => {
              history.push("/login");
            }}
          >
            {t("signup.button.login")}
          </span>
        </section>
      </section>
    </article>
  );
};
